// Custom Scripts
$(function () {
  mobileMenu();
  navHovers();
  form_control();
  form_control2();
  multiple_accord();
  play_video();
  modals();
  carousel();
  hashChangeScrollBuffer();
});

function play_video() {
  $(".video-thumbnail__link").on("click", function (e) {
    e.preventDefault();
    $(this).addClass("play-video");
    var $iframe = $(this).next(".c-video-thumbnail__video-wrap").find("iframe");
    src = $iframe.attr("src");
    $iframe.attr("src", src + "?&autoplay=1");
  });
  $(".video-thumbnail__close-icon").on("click", function (e) {
    var src = $(this).parent().find("iframe").attr("src");
    $(this)
      .parent()
      .find("iframe")
      .attr("src", src.replace("?&autoplay=1", ""));
    $(".video-thumbnail__link").removeClass("play-video");
  });
}

function multiple_accord() {
  $(".accord > ul > li:has(ul)").addClass("has-sub");
  $(".accord > ul > li:has(ul) > .toggle-first-level").each(function () {
    $(this).click(function () {
      $(this).parent().toggleClass("is-active");
    });
  });

  $(".accord > ul > li:has(ul) ul > li:has(ul)").addClass("has-sub");
  $(".accord > ul > li:has(ul) ul > li:has(ul) > i").each(function () {
    $(this).click(function () {
      $(this).parent().toggleClass("is-active");
    });
  });
}

function form_control() {
  $("#form_control").click(function () {
    let the_state = $(this).attr("state");
    if (the_state === "closed") {
      $(this).attr("state", "open");
      $("#the_suggestion_form").slideDown();
      $(this).text("Close Form");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#the_suggestion_form").offset().top,
        },
        1000,
      );
    }
    if (the_state === "open") {
      $(this).attr("state", "closed");
      $("#the_suggestion_form").slideUp();
      $(this).text("Open Form");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#the_form_intro").offset().top,
        },
        1000,
      );
    }
  });
}

function form_control2() {
  $("#form_control2").click(function () {
    let the_state = $(this).attr("state");
    if (the_state === "closed") {
      $(this).attr("state", "open");
      $("#the_registration_form").slideDown();
      $(this).text("Close Form");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#the_registration_form").offset().top,
        },
        1000,
      );
    }
    if (the_state === "open") {
      $(this).attr("state", "closed");
      $("#the_registration_form").slideUp();
      $(this).text("Open Form");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#the_form_intro").offset().top,
        },
        1000,
      );
    }
  });
}

function navHovers() {
  $("#primary_nav li").hover(
    function () {
      $(this).children(".sub-menu").show();
    },
    function () {
      $(this).children(".sub-menu").hide();
    },
  );
}

function mobileMenu() {
  // BUTTON CONTROL
  $("#mobile_expand").click(function () {
    $(this).hide();
    $("#mobile_close").fadeIn();
    $("#mobile_veil").fadeIn();
    // SCROLL TO TOP
    $("html, body").animate({ scrollTop: 0 });
    // OPENS MENU
    $("#mobile_menu").slideDown();
  });
  $("#mobile_close").click(function () {
    $(this).hide();
    $("#mobile_menu").slideUp();
    $("#mobile_veil").fadeOut();
    $("#mobile_expand").fadeIn();
    setTimeout(function () {
      $("#mobile_primary_nav li.menu-item-has-children .sub-menu").slideUp();
    }, 1000);
  });
  $("#mobile_primary_nav li.cta").click(function () {
    $("#mobile_close").hide();
    $("#mobile_menu").slideUp();
    $("#mobile_veil").fadeOut();
    $("#mobile_expand").fadeIn();
    setTimeout(function () {
      $("#mobile_primary_nav li.menu-item-has-children .sub-menu").slideUp();
    }, 1000);
  });
  // BACK TO TOP BUTTON IN HOVER VEIL
  $("#back_to_top").click(function () {
    $("html, body").animate({ scrollTop: 0 });
  });
  // CREATE BUTTONS TOP OPEN CHILD MENUS
  $("#mobile_primary_nav li.menu-item-has-children").each(function () {
    $(this).append('<button title="touch to open sub menu">&#xf0d7;</button>');
  });
  // OPEN CHILD MENUS
  $("#mobile_primary_nav li.menu-item-has-children button").each(function () {
    $(this).click(function () {
      $(this).siblings(".sub-menu").slideDown();
    });
  });
}

function modals() {
  const p_selector_modal = document.querySelectorAll("[data-p-open-modal]");
  const modals = document.querySelectorAll(".p-modal");
  const cancel_button = document.querySelectorAll("[data-p-cancel]");
  const modalBackground = document.querySelector(".p-modal-background");

  // Early return if required elements aren't found
  if (!modalBackground) {
    console.warn("Modal background element not found");
    return;
  }

  // Handle modal opening
  p_selector_modal.forEach((item) => {
    item.addEventListener("click", function (event) {
      event.preventDefault();
      const selector = this.getAttribute("data-p-open-modal");

      if (!selector) {
        console.warn("Error: data-p-open-modal attribute is empty");
        return;
      }

      const targetModal = document.querySelector(selector);
      if (!targetModal) {
        console.warn(`Error: No modal found with selector "${selector}"`);
        return;
      }

      modalBackground.classList.add("nowactive");
      document.body.classList.add("p-modal-opened");
      targetModal.classList.add("active");
    });
  });

  // Handle cancel button clicks
  cancel_button.forEach((element) => {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      const activeModal = document.querySelector(".p-modal.active");
      if (activeModal) {
        activeModal.classList.remove("active");
        modalBackground.classList.remove("nowactive");
        document.body.classList.remove("p-modal-opened");
      }
    });
  });

  // Handle outside clicks
  modalBackground.addEventListener("click", function (event) {
    event.preventDefault();
    const openedModal = document.querySelector(".p-modal.active");

    if (openedModal?.getAttribute("data-p-close-on-outside") === "true") {
      event.stopPropagation();
      openedModal.classList.remove("active");
      modalBackground.classList.remove("nowactive");
      document.body.classList.remove("p-modal-opened");
    }
  });

  // Prevent modal content clicks from closing
  modals.forEach((modal) => {
    modal.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  });
}

// CAROUSEL
function carousel() {
  const track = document.querySelector(".carousel__track");
  const slides = Array.from(track.children);
  const nextButton = document.querySelector(".carousel__button.-right");
  const prevButton = document.querySelector(".carousel__button.-left");
  const dotsNav = document.querySelector(".carousel__nav");
  const dots = Array.from(dotsNav.children);
  const slideWidth = slides[0].getBoundingClientRect().width;
  const setSlidePosition = (slide, index) => {
    slide.style.left = slideWidth * index + "px";
  };

  slides.forEach(setSlidePosition);

  const moveToSlide = (track, currentSlide, targetSlide) => {
    track.style.transform = "translateX(-" + targetSlide.style.left + ")";
    currentSlide.classList.remove("current-slide");
    targetSlide.classList.add("current-slide");
  };

  const updateDots = (currentDot, targetDot) => {
    currentDot.classList.remove("current-slide");
    targetDot.classList.add("current-slide");
  };

  const hideShowArrows = (slides, prevButton, nextButton, targetIndex) => {
    if (targetIndex === 0) {
      prevButton.classList.add("is-hidden");
      nextButton.classList.remove("is-hidden");
    } else if (targetIndex === slides.length - 1) {
      prevButton.classList.remove("is-hidden");
      nextButton.classList.add("is-hidden");
    } else {
      prevButton.classList.remove("is-hidden");
      nextButton.classList.remove("is-hidden");
    }
  };

  // click left -> move slides to the left
  prevButton.addEventListener("click", (e) => {
    const currentSlide = track.querySelector(".current-slide");
    const prevSlide = currentSlide.previousElementSibling;
    const currentDot = dotsNav.querySelector(".current-slide");
    const prevDot = currentDot.previousElementSibling;
    const prevIndex = slides.findIndex((slide) => slide === prevSlide);

    moveToSlide(track, currentSlide, prevSlide);
    updateDots(currentDot, prevDot);
    hideShowArrows(slides, prevButton, nextButton, prevIndex);
  });

  // click right -> move slides to the right
  nextButton.addEventListener("click", (e) => {
    const currentSlide = track.querySelector(".current-slide");
    const nextSlide = currentSlide.nextElementSibling;
    const currentDot = dotsNav.querySelector(".current-slide");
    const nextDot = currentDot.nextElementSibling;
    const nextIndex = slides.findIndex((slide) => slide === nextSlide);

    moveToSlide(track, currentSlide, nextSlide);
    updateDots(currentDot, nextDot);
    hideShowArrows(slides, prevButton, nextButton, nextIndex);
  });

  // click indicators -> move slides left or right
  dotsNav.addEventListener("click", (e) => {
    const targetDot = e.target.closest("button");
    if (!targetDot) return;

    const currentSlide = track.querySelector(".current-slide");
    const currentDot = dotsNav.querySelector(".current-slide");
    const targetIndex = dots.findIndex((dot) => dot === targetDot);
    const targetSlide = slides[targetIndex];

    moveToSlide(track, currentSlide, targetSlide);
    updateDots(currentDot, targetDot);
    hideShowArrows(slides, prevButton, nextButton, targetIndex);
  });
}

/** HASH CHANGE SCROLL BUFFER
 * Handles hash change events by adjusting scroll position
 * @param {number} offset - The amount of pixels to offset from the hash target
 */
function handleHashChange() {
  // Handle initial page load with hash
  if (window.location.hash) {
    adjustScroll();
  }

  // Handle hash changes
  window.addEventListener("hashchange", adjustScroll);

  function adjustScroll() {
    const hash = window.location.hash;
    if (!hash) return;

    // Delay execution to ensure default scroll has completed
    setTimeout(() => {
      const targetElement = document.querySelector(hash);
      if (!targetElement) return;

      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 100;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, 1);
  }
}

// END SCRIPTS
